import { useEffect } from 'react'

export const useAsyncApiScroll = (ref: HTMLDivElement | undefined, hash: string) => {
  useEffect(() => {
    let scrollTimeout: NodeJS.Timeout
    if (ref && hash) {
      const operation = hash.split('/').pop() || ''
      
      scrollTimeout = setTimeout(() => {
        const section = ref.querySelector(`[id*="${operation}"]`)
        section?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 200)
    }
    return () => clearTimeout(scrollTimeout)
  }, [hash, ref])
}